import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import {
  fetchDownloadImageSuccess,
  fetchDownloadFileSuccess,
} from '../actions/Download';
import { ActionTypes } from '../../constants/ActionTypes';
import { fetchError } from '../actions/Common';
import { ShowError } from '../../helper/Alert';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

// download any thing
const getDownloadImage = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get('dashboard/getRecentNews');
};
const getDownloadFile = async (src: string) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(src);
};

function* fetchDownloadImageRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedDownloadImage = yield call(getDownloadImage);
    yield put(fetchDownloadImageSuccess(fetchedDownloadImage.data));
  } catch (error) {
    return ShowError('', error);
  }
}

function* fetchDownloadFileRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedDownloadFile = yield call(getDownloadFile, action.payload);
    yield put(fetchDownloadFileSuccess(fetchedDownloadFile.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchDownloadImage() {
  yield takeEvery(ActionTypes.GET_DOWNLOAD_IMAGE, fetchDownloadImageRequest);
}

export function* fetchDownloadFile() {
  yield takeEvery(ActionTypes.GET_DOWNLOAD_File, fetchDownloadFileRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchDownloadImage), fork(fetchDownloadFile)]);
}
